export const formatPhone= (value) => {
    const clean = value.replace(/\D/g,'');
    const limited = clean.slice(0,9);
    return limited;
}